import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { Router } from '@angular/router';
import { PrijavaKorisnikService } from './prijava-korisnik.service';
import * as toastr from 'toastr';

@Component({
  selector: 'app-prijava-korisnik',
  templateUrl: './prijava-korisnik.component.html',
  styleUrls: ['./prijava-korisnik.component.css'],
  providers: [PrijavaKorisnikService]
})
export class PrijavaKorisnikComponent implements OnInit {

  videoForm: FormGroup;

  constructor(
    private _fb: FormBuilder,
    private _prijavaKorisnik: PrijavaKorisnikService,
    public _router: Router
  ) { }

  ngOnInit() {
    this.videoForm = this._fb.group({
      kljuc: ['']
    });
  }

  prikazi(data:any){
    // console.log(data);
    let podaciZaSlanje = {
      'sifra': data.kljuc
    };
    // console.log(podaciZaSlanje);
    this._prijavaKorisnik.provjeri(podaciZaSlanje).subscribe(res =>{
        //  console.log(res);
        if(res.message['video']){
          this._router.navigate(['/videoplayer', { v: res.message['video'], g: res.message['gledanjaBroj'], d: res.message['dozvoljenBroj'], n: res.message['nazivVidea'] }]);
        }
        if(res.error){
           toastr.error(res['message']);
        }
    });
  }

}


// WEBPACK FOOTER //
// C:/Users/TomislavS/Projekti/31-Holspico-VirtualnaUcionica/VirtualnaUcionica-Web/src/app/pages/vimeo/prijava-korisnik/prijava-korisnik.component.ts